import React from "react";

/** Consistent avatar palette — same clientId always maps to the same color */
const CHANGE_AVATAR_COLORS = [
  { bg: "#dcfce7", color: "#15803d" },
  { bg: "#fee2e2", color: "#dc2626" },
  { bg: "#ffedd5", color: "#ea580c" },
  { bg: "#dbeafe", color: "#1d4ed8" },
  { bg: "#ede9fe", color: "#6d28d9" },
];

export const getChangeAvatarStyle = (clientId) => {
  const key = String(clientId || "");
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  }
  return CHANGE_AVATAR_COLORS[hash % CHANGE_AVATAR_COLORS.length];
};

export const renderChangeDelta = (change) => {
  if (change == null || change === 0) {
    return <span className="db-delta-neutral">—</span>;
  }
  if (change > 0) {
    return (
      <span className="db-delta-up">
        +{change} <span className="db-delta-arrow">↑</span>
      </span>
    );
  }
  return (
    <span className="db-delta-down">
      {change} <span className="db-delta-arrow">↓</span>
    </span>
  );
};

export const renderChangeNote = (note) => {
  const text = String(note || "").trim();
  if (!text) {
    return <span className="db-change-note-empty">—</span>;
  }
  return (
    <span className="db-change-note" title={text}>
      {text}
    </span>
  );
};

/** Short date for AIP Change Center — e.g. "Jul 10" (current year) or "Jul 10, 2025". */
export const formatChangeDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const now = new Date();
  const opts = {
    month: "short",
    day: "numeric",
  };
  if (date.getFullYear() !== now.getFullYear()) {
    opts.year = "numeric";
  }
  return date.toLocaleDateString("en-US", opts);
};

export const renderChangeDate = (changeDate) => {
  const formatted = formatChangeDate(changeDate);
  if (!formatted) {
    return <span className="db-change-date-empty">—</span>;
  }
  return <span className="db-change-date">{formatted}</span>;
};

export const AIP_CHANGE_RANGE_OPTIONS = [
  { value: "today", label: "Today" },
  { value: "week", label: "This Week" },
  { value: "month", label: "This Month" },
];
